<template>
  <div>
    <page-title
      heading="Daftar Pasien"
      :breadcrumb="[
        {
          label: 'Daftar Pasien',
          link: '/pasien-klinik'
        },
        {
          label: 'List Pasien',
          active: true
        }
      ]"
    />

    <div class="container-fluid __zoom_display_pasien">
      <div class="card card-box mb-3 ninja-shadow">
        <div class="card-body">
          <div class="col-md-12 no-padding">
            <DataTableWrapper
              :perPage="perPage"
              :fromPage="fromPage"
              :toPage="toPage"
              :totalEntries="totalEntries"
              :currentPage="currentPage"
              :callbackFunc="fetchListPasien"
              @valueChanged="handleValueChanged"
            >
              <template v-slot:right-header>
                <b-button
                  v-if="hasFeatures('upload_patient')"
                  variant="success"
                  class="text-uppercase align-self-end mr-3"
                  :to="{
                    name: 'upload-pasien-klinik'
                  }"
                >
                  <font-awesome-icon icon="upload" />
                  upload data
                </b-button>
                <b-button
                  variant="primary"
                  class="text-uppercase align-self-end"
                  :to="{
                    name: 'pasien-klinik-tambah'
                  }"
                  v-if="hasFeatures('add_patient')"
                  >tambah pasien</b-button
                >
              </template>
              <div
                id="pasien-table"
                style="
                  overflow-x: scroll;
                  overflow-y: hidden;
                "
              >
                <b-table
                  :items="pasienList"
                  :fields="fieldList"
                  :sort-by.sync="sortBy"
                  :sort-desc.sync="sortDesc"
                  thead-tr-class="izd-datatable"
                  :no-local-sorting="true"
                  class="sticky-header-pasien"
                >
                  <template v-slot:head()="data">
                    {{ data.label }}
                    <b-input
                      size="sm"
                      class="mt-2 w-95"
                      v-if="data.field.searchable"
                      @input="searchValueChanged($event, data.field.key)"
                    />
                  </template>

                  <template v-slot:cell(nomor_rekam_medis)="data">
                    <div class="align-center">
                      {{ data.value }}
                      <span
                        v-if="
                          data.item.nomor_rekam_medis_manual !== null &&
                            data.item.nomor_rekam_medis_manual !== ''
                        "
                        :id="'rm-manual-' + data.item.id"
                        v-tooltip="{
                          content: `<strong>NO.RM MANUAL</strong><br/>${data.item.nomor_rekam_medis_manual}`,
                          classess: 'rm-manual'
                        }"
                      >
                        <font-awesome-icon
                          class="align-middle"
                          style="color: #33bdff; padding: 5px; font-size:2.3em; margin-top: -5px"
                          icon="clipboard-list"
                        />
                      </span>
                    </div>
                  </template>

                  <template v-slot:cell(nama)="data">
                    <div v-if="checkValueData(data.item.tanggal_lahir) && data.item.tanggal_lahir != '0000-00-00'">
                      {{ data.value }}
                    </div>
                    <div v-else>
                      {{ data.item.nama_pasien }}
                    </div>
                  </template>

                  <template v-slot:cell(jenis_kelamin)="data">
                    {{ jenisKelamin(data.value) }}
                  </template>

                  <template v-slot:cell(nomor_hp)="data">
                    <div v-if="data.item.kewarganegaraan == 'WNA' && !checkValueData(data.value)">-</div>
                    <div v-else>
                      {{ data.item.nomor_hp_prefix ? `+${data.item.nomor_hp_prefix}` : '' }}{{ data.value }}
                    </div>
                  </template>

                  <template v-slot:cell(actions)="data">
                    <span>
                      <b-dropdown
                        id="dropdown-1"
                        class="m-md-2 text-capitalize"
                        variant="primary"
                        size="sm"
                        right
                      >
                        <template v-slot:button-content>
                          <font-awesome-icon icon="copy" />
                        </template>
                        <b-dropdown-item
                          v-if="hasFeatures('edit_patient')"
                          @click="
                            editPasien({
                              id: data.item.id
                            })
                          "
                          >edit data pasien</b-dropdown-item
                        >

                        <b-dropdown-item
                          @click="
                            detailPasien({
                              id: data.item.id
                            })
                          "
                          >view detail pasien</b-dropdown-item
                        >
                        <b-dropdown-item
                          v-if="hasFeatures('delete_patient')"
                          @click="
                            removePasien({
                              id: data.item.id,
                              nama: data.item.nama
                            })
                          "
                          >hapus data pasien</b-dropdown-item
                        >
                        <b-dropdown-item
                          v-if="hasFeatures('print_card')"
                          @click="
                            cetakKartuPasien({
                              id: data.item.id,
                              nama: data.item.nama
                            })
                          "
                          >cetak kartu pasien</b-dropdown-item
                        >
                      </b-dropdown>
                    </span>
                  </template>
                  <template v-slot:cell(last_modified)="data">
                      <label style="font-size:12px;">
                          {{ data.item.updated.at }} <br>
                          by <b>{{ data.item.updated.by }}</b>
                      </label>
                  </template>
                </b-table>
              </div>
            </DataTableWrapper>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import startCase from "lodash/startCase";
import debounce from "lodash/debounce";
import { library } from "@fortawesome/fontawesome-svg-core";
import {
  faArrowRight,
  faArrowUp,
  faTrashAlt,
  faSearch,
  faPencilAlt,
  faCopy,
  faClipboardList,
  faUpload
} from "@fortawesome/free-solid-svg-icons";
import moment from "moment";
moment.locale("id");
import "vue-datetime/dist/vue-datetime.css";

library.add(
  faArrowRight,
  faArrowUp,
  faTrashAlt,
  faSearch,
  faPencilAlt,
  faCopy,
  faUpload,
  faClipboardList
);

export default {
  components: {
    DataTableWrapper: () => import("../../components/DataTableWrapper")
  },
  data() {
    return {
      sortBy: "",
      sortDesc: false,
      currentPage: 1,
      rows: 0,
      fromPage: 0,
      toPage: 0,
      perPage: 10,
      pasienList: [],
      namaPasien: "",
      isOperator: "",
      noRekamMedis: "",
      tanggalLahir: "",
      checkPaketData: null,
      searchValue: [],
      totalEntries: 0,
    };
  },
  created() {
    window.addEventListener('resize', this.eventHandlerOrientation);
  },
  destroyed() {
    window.removeEventListener('resize', this.eventHandlerOrientation);
  },
  async mounted() {
    await this.cekPaketNolock();
    if (!this.isDoctor) {
      this.isOperator = true;
    } else {
      this.isOperator = false;
    }
  },
  watch: {
    currentPage() {
      this.fetchListPasien();
    },
    perPage() {
      this.fetchListPasien();
    },
    sortBy() {
      this.fetchListPasien();
    },
    sortDesc() {
      this.fetchListPasien();
    },
    searchValue: {
      handler: "fetchListPasien",
      deep: true
    }
  },
  computed: {
    ...mapGetters({
      isDoctor: "doctorRole",
      getRolesName: "getRolesName",
      getKlinikId: "getKlinikId"
    }),
    fieldList() {
      const {
        generateFieldList: g,
        setSearchableAndSortableFieldList: s
      } = this;
      const r = val => Boolean(/(no|actions|last_modified)\b/gi.test(val) ? !1 : 1);
      return (
        [
          {
            key: "no"
          },
          {
            key: "nomor_rekam_medis",
            thStyle: "min-width:190px;"
          },
          {
            key: "nama",
            label: "nama pasien",
            thStyle: "min-width:200px;"
          },
          {
            key: "jenis_kelamin",
            thStyle: "min-width:140px;"
          },
          {
            key: "nomor_hp",
            thStyle: "min-width:160px;"
          },
          {
            key: "actions",
            thStyle: "min-width:100px;"
          },
          {
            key: "last_modified",
            label: "last modified",
            thStyle: "min-width:150px;"
          },
        ]
        |> (v => s({ field: v, customFunc: r }))
        |> (z => g({ field: z }))
      );
    },
  },
  methods: {
    hasFeatures(value) {
      const features = {
        add_patient: ["pic_cabang", "frontdesk", "kasir"],
        edit_patient: ["pic_cabang", "frontdesk", "kasir"],
        delete_patient: ["pic_cabang", "frontdesk", "kasir"],
        upload_patient: ["pic_cabang", "frontdesk", "kasir"],
        print_card: ["pic_cabang", "frontdesk", "kasir"]
      };

      const isOwner = features[value].filter(feature => {
        return this.getRolesName.includes(feature);
      });

      return isOwner.length > 0 ? true : false;
    },
    handleValueChanged({ perPage, currentPage }) {
      perPage && (perPage |> (_ => (this.perPage = _)));
      currentPage && (currentPage |> (_ => (this.currentPage = _)));
    },
    searchValueChanged: debounce(function(val, key) {
      const { searchValue } = this;

      const z = searchValue.filter(item => item.key !== key);
      this.searchValue = [
        ...z,
        {
          key,
          value: val
        }
      ];
    }, 500),
    rekamMedis({ pasien_id }) {
      localStorage.setItem("rekam_medis", window.location.pathname);
      this.$router.push({
        name: "riwayat-rekam-medis",
        params: {
          pasien_id: pasien_id
        }
      });
    },
    removePasien({ id, nama = null } = {}) {
      this.$swal({
        text: `Apakah Anda yakin ingin menghapus data pasien ${nama}?`,
        type: "question",
        showCancelButton: true,
        cancelButtonText: startCase("tidak"),
        confirmButtonText: startCase("ya"),
        confirmButtonColor: "#1791EE",
      }).then(async res => {
        if (res.value) {
          await this.deletePasien(id);
        }
      });
    },
    editPasien({ id } = {}) {
      if (id) {
        this.$router.push({
          name: "pasien-klinik-edit",
          params: {
            idPasien: id
          },
          query: {
            klinik_id: this.getKlinikId
          }
        });
      }
    },
    detailPasien({ id } = {}) {
      if (id) {
        this.$router.push({
          name: "pasien-klinik-detail",
          params: {
            idPasien: id
          },
          query: {
            klinik_id: this.getKlinikId
          }
        });
      }
    },
    async deletePasien(id) {
      try {
        const res = await this.$axios.delete(
          `pasien/${id}?klinik_id=${this.getKlinikId}`
        );
        const { status, data } = res.data;
        if (status) {
          this.$swal({
            type: "success",
            title: startCase("deleted"),
            text: startCase("pasien berhasil di hapus")
          });
          this.fetchListPasien();
        } else {
          this.$swal({
            type: "error",
            title: startCase("gagal"),
            text: startCase(
              "Anda tidak dapat menghapus pasien yang sudah aktif atau memiliki aktivitas"
            )
          });
        }
      } catch (err) {
        this.$swal({
          type: "error",
          title: startCase("gagal"),
          text: startCase("pasien gagal di hapus")
        });
      }
    },
    cetakKartuPasien(param) {
      this.$router.push({
        name: "kartu-pasien-klinik",
        params: {
          id: param.id
        },
        query: {
          klinik_id: this.getKlinikId
        }
      });
    },
    determineParameter() {
      const { searchValue, sortBy, sortDesc } = this;
      let v = "";
      searchValue.map(item => {
        const x = (item.key === "nama" && "nama_pasien") || item.key;
        v += `&${x}=${item.value}`;
      });

      if (sortBy) {
        v += `&column=${sortBy}&order=${sortDesc ? "desc" : "asc"}`;
      }

      return v;
    },
    async fetchListPasien() {
      try {
        const res = await this.$axios.get(
          `pasien?klinik_id=${this.getKlinikId}&limit=${
            this.perPage
          }&page=${this.currentPage}${this.determineParameter()}`
        );
        const { success, data } = res.data;
        if (success) {
          const {
            data: listPasien,
            total: totalEntries,
            to: toPage,
            from: fromPage
          } = data;
          this.totalEntries = totalEntries;
          this.toPage = toPage;
          this.fromPage = fromPage;
          this.pasienList = [
            ...listPasien.map((item, index) => {
              return {
                ...item,
                no: (this.currentPage - 1) * this.perPage + index + 1,
                updated: {
                  at: moment(item.updated.at).format("MMM DD, YYYY @ HH:mm"),
                  by: item.updated.by || 'anonim'
                }
              };
            })
          ];
          this.rows = data.total;
          return this;
        }
      } catch (err) {
        // console.log(err);
      }
    },
    formatedDate(d) {
      return moment(d).format("D MMM YYYY");
    }
  }
};
</script>
<style lang="css">
.bg-kuning {
  background: #f7fc6b;
}

.bg-kuning,
.bg-danger,
.bg-first {
  color: black !important;
}

.no-padding {
  padding: 0 !important;
}

.page-item.active a {
  background: #3b86ff;
  border: none !important;
}

.ninja-shadow {
  box-shadow: 0px 8px 15px 0px lightgrey;
}

.tooltip {
  display: block !important;
  z-index: 10000;
}

.tooltip .tooltip-inner {
  background: rgb(18, 106, 207);
  color: white;
  border-radius: 5px;
  padding: 5px 10px 4px;
  box-shadow: 0px 0px 0px rgba(black, .1) !important;
}

.tooltip .tooltip-arrow {
  width: 0;
  height: 0;
  border-style: solid;
  position: absolute;
  margin: 5px;
  border-color: rgb(18, 106, 207);
  z-index: 1;
}

/* width */
#pasien-table::-webkit-scrollbar {
  width: 5px;
}

/* Track */
#pasien-table::-webkit-scrollbar-track {
  box-shadow: inset 0 0 1px grey;
  border-radius: 10px;
}

/* Handle */
#pasien-table::-webkit-scrollbar-thumb {
  background: #cdcdcd;
  border-radius: 10px;
}

/* Handle on hover */
#pasien-table::-webkit-scrollbar-thumb:hover {
  background: #cdcdcd;
}

@media only screen and (max-width: 1550px) and (min-width: 1280px) {
  body {
    overflow-x: hidden;
  }
  ::-webkit-scrollbar {
    width: initial;
  }

  #pasien-table {
    max-width: 100% !important;
  }
}

@media screen and (min-width: 1551px) {
  body {
    overflow-x: visible;
  }

  body::-webkit-scrollbar-track {
    box-shadow: inset 0 0 1px grey;
    border-radius: 10px;
  }

  body::-webkit-scrollbar-thumb {
    background: #cdcdcd;
    border-radius: 10px;
  }

  #pasien-table {
    max-width: 100% !important;
  }
}

.sticky-header-pasien th {
  position: -webkit-sticky;
  position: sticky;
  top: -2px;
  z-index: 1;
}

/* .__zoom_display_pasien {
  transform: scale(0.9);
  width: 113%;
  margin-left: -6.5%;
  margin-top: -10% !important;
} */

@media screen and (max-width: 1000px) {
  .__zoom_display_pasien {
    transform: scale(0.9);
    width: 113%;
    margin-left: -6.5%;
    margin-top: -1% !important;
  }
}
</style>